import React from 'react';
import { useTranslation } from 'react-i18next';

import FormInput from 'commons/Form/FormInput';

import useStyles from './styles';

const CollectionFormBody = ({ collection, onCollectionChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <FormInput
        value={collection}
        label={t('institutional_name')}
        placeholder={t('enter_name')}
        onChange={onCollectionChange}
        textFieldStyle={classes.textFieldStyle}
      />

      {/* Ẩn tính năng visibility
      <div className={classes.wrapIosSwitch}>
        <IosSwitch
          isChecked={isPublic}
          onSwitchChange={onSwitchChange}
        />
        <Text
          className={classes.textPublicProfile}
          mt={12}
        >
          {isPublic ? t('public_on_profile') : t('private')}
        </Text>
      </div>
      */}
    </>
  );
};

export default CollectionFormBody;
